import { gql } from '@apollo/client'
import { PRODUCT_FRAGMENT } from '../fragments'

export const UPDATE_PRODUCT = gql`
  mutation UpdateProduct($input: UpdateProductInput!) {
    updateProduct(input: $input) {
      product {
        ...Product
      }
    }
  }
  ${PRODUCT_FRAGMENT}
`
